import { render, staticRenderFns } from "./PowerGrowthChart.vue?vue&type=template&id=8e937c00&scoped=true"
import script from "./PowerGrowthChart.vue?vue&type=script&lang=js"
export * from "./PowerGrowthChart.vue?vue&type=script&lang=js"
import style0 from "./PowerGrowthChart.vue?vue&type=style&index=0&id=8e937c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e937c00",
  null
  
)

export default component.exports